import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { RoutingProfileAction } from '../routingProfile.action';
import { RoutingProfileTranslator } from '../routingProfile.translator';

type IDependencies = IClientApiDependencySegment;

export const loadRoutingProfileListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(RoutingProfileAction.loadList.started),
  mergeMap(() => {
    return dependencies.api.getRoutingProfileList().pipe(
      mergeMap((response) => {
        return [
          RoutingProfileAction.loadList.done({
            result: {
              data: (response.profiles ?? []).map(RoutingProfileTranslator.fromApi),
              defaultData: RoutingProfileTranslator.defaultFromApi(response.default),
            },
          }),
        ];
      }),
      catchApiError((error) => {
        return [
          RoutingProfileAction.loadList.failed({ error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
